import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({ name: 'luxonFromNow' })
export class LuxonFromNowPipe implements PipeTransform {
    transform(value: string | Date | DateTime): string {
      if (!value) return '';
  
      let dateTime: DateTime;
  
      if (value instanceof Date) {
        dateTime = DateTime.fromJSDate(value);
      } else if (typeof value === 'string') {
        dateTime = DateTime.fromISO(value);
      } else {
        dateTime = value;
      }
  
      return dateTime.isValid ? dateTime.toRelative() ?? '' : '';
    }
}
